module.exports = __webpack_public_path__ + "static/media/YF39_1.5cff1bdb.jpg";